import { Component, OnInit, Inject } from '@angular/core';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import {formatDate} from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-cross-bd',
  templateUrl: './cross-bd.component.html',
  styleUrls: ['./cross-bd.component.css']
})
export class CrossBdComponent implements OnInit {
  crossBDForm: FormGroup;lead_id='';modalData:any;alltreatments=[];treatments_copy=[];treatment_modal='';allTls=[];tls_copy=[];tl_modal='';lead_data=[];lead_name='';mobile='';city_name='';created_at='';loading:boolean=false;submitted:boolean=false;
  constructor(private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder,public dialogRef: MatDialogRef<CrossBdComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog) { 
    this.modalData = data;
    this.getTreatment();
    this.getLeadDetail();
    this.getTLs();
    this.crossBDForm = this.formBuilder.group({ 
      'tid' : [null, Validators.required],
      'tlid' : [null, Validators.required],
    });
  }
  get f() { return this.crossBDForm.controls; }
  ngOnInit(): void {
    
  }

  CloseModal(): void {
    this.dialogRef.close({event:'Cancel'});
  }

  async getTreatment()
  {
      await this.leadapi.getTreatments().subscribe((data:any) => {
          if(data.status)
          {
              this.alltreatments = data.data;
              this.treatments_copy = this.alltreatments;
          }else{
              this.alltreatments = [];
          }
      }, error => {
          this.sharedapi.checkError(error);
      });
  }

  async getTLs()
  {
    await this.leadapi.getTls().subscribe((data:any) => {
        if(data.status)
        {
            this.allTls = data.data;
            this.tls_copy = this.allTls;
        }else{
            this.allTls = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getLeadDetail()
  {
    await this.leadapi.getLeadDetail(this.modalData.cross_bd_lead_id).subscribe((data:any) => {
        if(data.status)
        {
          
            this.crossBDForm.patchValue({
              'tid':data.data.treatment_id,  
            })
           
            this.lead_name=data.data.lead_name;
            this.mobile=data.data.mobile;
            this.city_name=data.data.city_name;
            this.created_at= formatDate(data.data.created_at*1000, 'dd MMM, yyyy hh:mm aa', 'en-US');
        }else{
          this.lead_name='';
          this.mobile='';
          this.city_name='';
          this.created_at= '';
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  setSearchValue(type){
    if(type=='treatment_modal'){
        $("#treatmentModalSearch").val('');
        $("#treatmentModalSearch").focus();
        this.alltreatments= this.treatments_copy;
    }else if(type=='tl'){
      $("#tlModalSearch").val('');
      $("#tlModalSearch").focus();
      this.allTls= this.tls_copy;
    }
  }

  searchOnSelect(searchtText: string, type){
    if (type == 'treatment_modal') {
        this.alltreatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
    }
    if (type == 'tl_modal') {
      this.allTls = this.sharedapi.searchData(searchtText, this.tls_copy, "name");
    }
  }

  SaveData()
  {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.crossBDForm.invalid) {
        this.loading = false;
        return;
    }
    this.crossBDForm.value.id= parseInt(this.modalData.cross_bd_lead_id); 
    this.leadapi.saveCrossBDData(this.crossBDForm.value).subscribe((data:any) => {
      this.submitted = false;
      this.loading = false;
      if(data.status)
      {
          this.sharedapi.presentToast(data.msg);
          this.dialogRef.close();
      }
      else
      {
          this.sharedapi.presentToast(data.msg);
      }
    }, error => 
    {
        this.sharedapi.checkError(error);
    });  
  }

}
